module.exports = __webpack_public_path__ + "img/5active.1018bf9c.png";